import { api } from "./api";

const VID_KEY = "nx_vid";
const SID_KEY = "nx_sid";
const ATTR_KEY = "nx_attr";

function uid() {
  try {
    return crypto.randomUUID();
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  }
}

export function getVisitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      v = uid();
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch {
    return "anon";
  }
}

export function getSessionId() {
  try {
    let s = sessionStorage.getItem(SID_KEY);
    if (!s) {
      s = uid();
      sessionStorage.setItem(SID_KEY, s);
    }
    return s;
  } catch {
    return "anon";
  }
}

function getAttribution() {
  try {
    const cached = sessionStorage.getItem(ATTR_KEY);
    if (cached) return JSON.parse(cached);
    const params = new URLSearchParams(window.location.search);
    const ref = document.referrer || "";
    const external = ref && !ref.includes(window.location.host) ? ref : "";
    const attr = {
      referrer: external.slice(0, 300),
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
    };
    sessionStorage.setItem(ATTR_KEY, JSON.stringify(attr));
    return attr;
  } catch {
    return {};
  }
}

function deviceType() {
  const w = window.innerWidth || 1024;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

function browserName() {
  const ua = navigator.userAgent || "";
  if (ua.includes("Edg/")) return "Edge";
  if (ua.includes("OPR/") || ua.includes("Opera")) return "Opera";
  if (ua.includes("Chrome/")) return "Chrome";
  if (ua.includes("Firefox/")) return "Firefox";
  if (ua.includes("Safari/")) return "Safari";
  return "Other";
}

export function track(eventType, props = {}) {
  try {
    const attr = getAttribution();
    api
      .post("/track", {
        event_type: eventType,
        page_path: window.location.pathname,
        page_title: (document.title || "").slice(0, 240),
        referrer: attr.referrer || undefined,
        utm_source: attr.utm_source || undefined,
        utm_medium: attr.utm_medium || undefined,
        utm_campaign: attr.utm_campaign || undefined,
        device_type: deviceType(),
        browser: browserName(),
        session_id: getSessionId(),
        visitor_id: getVisitorId(),
        ...props,
      })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.warn("analytics: event not recorded", eventType, err?.message);
        }
      });
  } catch {
    // analytics must never break the UI
  }
}

const firedOnce = new Set();
export function trackOnce(key, eventType, props = {}) {
  if (firedOnce.has(key)) return;
  firedOnce.add(key);
  track(eventType, props);
}

// Attach anonymous ids to all public API calls so the backend can link
// server-generated conversion events (inquiry_submitted) to the session.
api.interceptors.request.use((config) => {
  try {
    const attr = getAttribution();
    config.headers["X-Nx-Session"] = getSessionId();
    config.headers["X-Nx-Visitor"] = getVisitorId();
    if (attr.referrer) config.headers["X-Nx-Ref"] = encodeURIComponent(attr.referrer).slice(0, 300);
    if (attr.utm_source) config.headers["X-Nx-Utm-Source"] = encodeURIComponent(attr.utm_source);
    if (attr.utm_medium) config.headers["X-Nx-Utm-Medium"] = encodeURIComponent(attr.utm_medium);
    if (attr.utm_campaign) config.headers["X-Nx-Utm-Campaign"] = encodeURIComponent(attr.utm_campaign);
  } catch {
    // ignore
  }
  return config;
});
